<template>
  <gravy-modal
      v-on:modal:cancel="open = false"
      v-on:modal:perform="$emit('modal:perform')"
      :open="open">
    <template v-slot:icon>
      <div class="mx-auto flex items-center justify-center h-14 w-14 p-2 rounded-full bg-red-100">
        <ExclamationIcon class="text-red-600" />
      </div>
    </template>
    <template v-slot:title>
      {{ title }}
    </template>
    <template v-slot:content>
      {{ content }}
    </template>
    <template v-slot:cancelButton>
      <neutral-button type="button"
                      :text="cancelButtonText"
                      @click="$emit('modal:cancel')" ref="cancelButtonRef">
        Cancel
      </neutral-button>
    </template>
    <template v-slot:actionButton>
      <danger-button :text="actionButtonText" @click="$emit('modal:perform')">

      </danger-button>
    </template>
  </gravy-modal>
</template>

<script>
import GravyModal from "@/components/Functional/Modal/GravyModal";
import { ExclamationIcon } from '@heroicons/vue/outline'
import NeutralButton from "@/components/Functional/Buttons/NeutralButton";
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import DangerButton from "@/components/Functional/Buttons/DangerButton";
export default {
  name: "DangerModal",
  components: {
    DangerButton,
    GravyModal,
    ExclamationIcon,
    NeutralButton,
    PrimaryButton
  },
  props: {
    open: {},
    title: {},
    content: {},
    cancelButtonText: {},
    actionButtonText: {},
  },
  emits: ['modal:cancel', 'modal:perform'],
}
</script>

<style scoped>

</style>